import * as React from 'react';
import { Dialog as DialogMui, Grid } from '@mui/material';
import { Button, SwipeDrawer } from '.';
import AppService, { maxwidth } from '../services/app.service';

interface Props {
  id?: string;
  open: boolean;
  maxWidth?: maxwidth ;
  onClose?: () => void;
  children?: React.ReactNode;
}

export const Dialog: React.FunctionComponent<Props> = (props) => {
  const isMobile = AppService.isMobile();

  return (
    <>
    {isMobile && props.onClose?
      <SwipeDrawer type='bottom' open={props.open || false} onClose={props.onClose}>
        {props.children}
      </SwipeDrawer>
    :
      props.open &&
      <DialogMui open fullWidth maxWidth={props.maxWidth || 'md'} PaperProps={{sx: {backgroundColor: 'white', borderRadius: 5, overflow: 'hidden', padding: props.onClose? 3 : 1 } }}> 
        {props.onClose &&
        <Button startIcon='close' color='primary.dark' size='small' sx={{position: 'absolute', right: '2%', top: 15}} onClick={props.onClose} />
        }
        <Grid container justifyContent='center'>
          {props.children}
        </Grid>
      </DialogMui>
    }
    </>
  );
}
